export async function renderGamesPage(container) {
  // Show loading state
  container.innerHTML = `
    <section class="rm-page">
      <div class="rm-container">
        <div class="rm-page-header">
          <h1 class="rm-page-title">Games</h1>
          <p class="rm-page-description">Web games and interactive experiments</p>
        </div>
      </div>
    </section>
  `;

  try {
    const response = await fetch('/games/games.json');
    let games = [];

    if (response.ok) {
      games = await response.json();
    }

    renderGames(container, games);
  } catch (error) {
    console.error('Error rendering games page:', error);
    container.innerHTML = `
      <section class="rm-page">
        <div class="rm-container">
          <div class="rm-page-header">
            <h1 class="rm-page-title">Games</h1>
            <p class="rm-page-description">Unable to load games</p>
          </div>
        </div>
      </section>
    `;
  }
}

function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

function renderGames(container, games) {
  if (!games || !Array.isArray(games)) {
    games = [];
  }

  const gamesHTML = games.map(game => `
    <a href="/games/${escapeHtml(game.slug)}" class="rm-project-item rm-game-item">
      <div class="rm-project-image rm-game-thumbnail" style="background-image: url('${escapeHtml(game.thumbnail || '/images/placeholder.svg')}'); background-size: cover; background-position: center;"></div>
      <div class="rm-project-info">
        <div class="rm-project-meta">
          <span class="rm-project-category">${escapeHtml(game.category || 'Game')}</span>
          <span class="rm-project-year">${escapeHtml(game.year || '2024')}</span>
        </div>
        <h3 class="rm-project-title">${escapeHtml(game.title)}</h3>
        <p class="rm-project-description">${escapeHtml(game.description)}</p>
        ${game.technologies && game.technologies.length > 0 ? `
          <div class="rm-project-tech">
            ${game.technologies.map(tech => `<span class="rm-tech-tag">${escapeHtml(tech)}</span>`).join('')}
          </div>
        ` : ''}
      </div>
    </a>
  `).join('');

  const emptyMessage = games.length === 0 ? `
    <div class="rm-empty-state">
      <p class="rm-empty-message">No games available yet.</p>
    </div>
  ` : '';

  container.innerHTML = `
    <section class="rm-page">
      <div class="rm-container">
        <div class="rm-page-header">
          <h1 class="rm-page-title">Games</h1>
          <p class="rm-page-description">Web games and interactive experiments</p>
        </div>

        <div class="rm-projects-grid rm-games-grid">
          ${emptyMessage}
          ${gamesHTML}
        </div>
      </div>
    </section>
  `;
}

export async function renderGameDetailPage(container, slug) {
  container.innerHTML = `
    <section class="rm-page">
      <div class="rm-container">
        <div class="rm-loading">Loading game...</div>
      </div>
    </section>
  `;

  try {
    const response = await fetch('/games/games.json');
    let game = null;

    if (response.ok) {
      const games = await response.json();
      game = games.find(g => g.slug === slug);
    }

    if (!game) {
      container.innerHTML = `
        <section class="rm-page">
          <div class="rm-container">
            <div class="rm-page-header">
              <a href="/games" class="rm-back-link">← Back to Games</a>
              <h1 class="rm-page-title">Game Not Found</h1>
              <p class="rm-page-description">The game you're looking for doesn't exist.</p>
            </div>
          </div>
        </section>
      `;
      return;
    }

    renderGameDetail(container, game);
  } catch (error) {
    console.error('Error loading game:', error);
    container.innerHTML = `
      <section class="rm-page">
        <div class="rm-container">
          <div class="rm-page-header">
            <a href="/games" class="rm-back-link">← Back to Games</a>
            <h1 class="rm-page-title">Error Loading Game</h1>
            <p class="rm-page-description">Something went wrong.</p>
          </div>
        </div>
      </section>
    `;
  }
}

function renderGameDetail(container, game) {
  const gameUrl = `/games/${escapeHtml(game.folder)}/index.html`;

  container.innerHTML = `
    <section class="rm-page rm-game-page">
      <div class="rm-container">
        <div class="rm-game-header">
          <a href="/games" class="rm-back-link">← Back to Games</a>
          <div class="rm-game-title-row">
            <h1 class="rm-page-title">${escapeHtml(game.title)}</h1>
            <button class="rm-game-fullscreen-btn" id="fullscreen-btn">
              Fullscreen ⛶
            </button>
          </div>
          <p class="rm-page-description">${escapeHtml(game.description)}</p>
          ${game.technologies && game.technologies.length > 0 ? `
            <div class="rm-project-tech">
              ${game.technologies.map(tech => `<span class="rm-tech-tag">${escapeHtml(tech)}</span>`).join('')}
            </div>
          ` : ''}
        </div>

        <div class="rm-game-container" id="game-container">
          <iframe
            src="${gameUrl}"
            class="rm-game-iframe"
            id="game-iframe"
            title="${escapeHtml(game.title)}"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </section>
  `;

  // Set up fullscreen button
  const fullscreenBtn = document.getElementById('fullscreen-btn');
  const gameContainer = document.getElementById('game-container');

  fullscreenBtn.addEventListener('click', () => {
    if (gameContainer.requestFullscreen) {
      gameContainer.requestFullscreen();
    } else if (gameContainer.webkitRequestFullscreen) {
      gameContainer.webkitRequestFullscreen();
    } else if (gameContainer.mozRequestFullScreen) {
      gameContainer.mozRequestFullScreen();
    } else if (gameContainer.msRequestFullscreen) {
      gameContainer.msRequestFullscreen();
    }
  });

  // Update button text based on fullscreen state
  document.addEventListener('fullscreenchange', () => {
    if (document.fullscreenElement) {
      fullscreenBtn.textContent = 'Exit Fullscreen ⛶';
    } else {
      fullscreenBtn.textContent = 'Fullscreen ⛶';
    }
  });
}
